import "./SectionWrapper.css";
import { Typography } from "@mui/material";

interface SectionWrapperProps {
  title: string;
  children: React.ReactNode;
}

const SectionWrapper = ({ title, children }: SectionWrapperProps) => (
  <div className="section-wrapper">
    <Typography variant="h4">{title}</Typography>
    {children}
  </div>
);

export default SectionWrapper;
